<template>
    <div class="cardBox">
        <div class="sumCardBox" v-if="type == 'sumCardBox'">
            <b-card v-for="card in cards" :key="card.id" class="sumCard" :bg-variant="card.widget.class" :text-variant="card.widget.class == 'warning' ? 'black' : 'white'">
                <div class="cardIcon"> <b-icon :icon="card.widget.Icon"></b-icon> </div>
                <div class="cardDesc">
                    <span> {{Math.floor(widgetVal.find(wv => wv.key == card.widget.key) && widgetVal.find(wv => wv.key == card.widget.key).value)}} </span>
                    <b-card-text> {{card.widget.name}} </b-card-text>
                </div>
            </b-card>
        </div>
        <div class="listCardBox" style="position: relative;" v-if="type == 'listCardBox'">
            <div class="listCard" v-for="card in cards" :key="card.id">
                <Table v-if="getItems(card)" :title="card.widget.name" :fields="getFields(card.widget.key)" :items="getItems(card)" :filtered="getFilter(card.widget.key)" noHeader />
                <a :href="getUrl(card.widget.key)" style="position:absolute; bottom: -20px; "> Tümünü Gör </a>  
            </div>
        </div>
    </div>
    
</template>

<script>
import Table from "@/components/Table"
import i18n from '@/plugins/i18n';

export default {
    name: 'Card',
    data: function(){
        return{
        CSTMR_fields: [ 
         { key: 'name', label: i18n.t('customer.list.title'), keys:['name'] },
         { key: 'address', label: i18n.t('customer.list.address'), keys:['address']},
         { key: 'created_date', type:"date", label: i18n.t('customer.list.date'), keys:['created_date'] },
         { key: 'active', label: i18n.t('customer.list.state') , keys:['active']},
         { key: 'is_approve', label: i18n.t('customer.list.approve') , keys:['is_approve']},
        ],
        SS_fields: [ 
            { key: "barcode", label: "Stok Kodu", keys: ["barcode"] },
            { key: "name", label: "Adı", keys: ["name"] },
            { key: "quantity", label: "Mevcut Adet", keys: ["quantity"] }
        ],
        WH_fields: [ 
            { key: "name", label: "Adı", keys: ["name"] },
            { key: "type", type:'data', data:{true: {text: 'Takip Dışı', variant: 'dark'}, false: {text: 'Takip Edilecek', variant: 'success'}}, label: "Depo Tipi", keys: ["is_technical"] },
            { key: "total_product_count", label: "Toplam Ürün", keys: ["total_product_count"] },
        ]
        }
    },
    props:{
        type: String,
        cards: Array
    },
    components:{
        Table
    },
    created: async function(){
        this.cards.map( async c =>{
             await this.$store.dispatch('getWidgetValue', {url: c.widget.endpoint, key: c.widget.key})
        })
    },
    computed:{
        widgetVal: function(){
            return this.$store.getters.getWidgetVal
        },
        CSTMR_data: function(){
            return this.$store.getters.customerList
        }
    },
    methods:{
         getVariant(data){
            let variants = ['primary','success','info','danger','dark']
            
            return variants[(data-1)%5]
        },
        getItems(card){
            let data = this.widgetVal.find(wv => wv.key == card.widget.key)
            if(data)
                return data.value
            return []
        },
        getFields(key){
            return this[key+'_fields']
        },
        getFilter(key){
            if(this[key+'_fields']){
                return this[key+'_fields'].map(f => f.key)

            }
        },
        getUrl(key){
            switch(key){
                case 'CSTMR': 
                    return '/Customer/List';
                case 'WH': 
                    return '/Warehouse/List'
                case 'SS': 
                    return '/Stock/List'
            }
            return this[key+'_fields']
        },
    
    }
}
</script>

<style scoped>
    @import "./styles/cards.min.css";

</style>

<!--

 <b-card class="listCard" v-for="card in cards" :key="card.id" bg-variant="default"  header="header">
               <template v-slot:header  >
                    <b-icon icon="envelope" v-if="card.type == 'msg'"/>
                    <b-icon icon="app-indicator" v-if="card.type == 'ntf'"/>
                    <div class="title" > {{card.title}} </div>
                    <span  class="detailText"> <a href="#"> {{$t('general.seeAll')}} </a> </span>  
                </template>
               <b-list-group>
                    <b-list-group-item v-for="item in card.data" :key="item.id"> 
                        <div class="lgiIcon">
                            <b-icon v-if="card.type == 'msg'" icon="envelope" animation="throb" variant="warning"/>
                            <b-icon v-else icon="circle-fill" animation="throb" variant="primary" />

                        </div>
                        <div class="lgiContent"> 
                            <div class="lgiDesc">                
                                <span> {{ item.title }} </span>
                            </div>
                            <div class="lgiInfo">
                                <span> <b-icon icon="calendar-date-fill"></b-icon> <span> {{item.date}} </span> </span>
                                <span> <b-icon v-if="card.type == 'msg'" icon="person-fill"></b-icon> {{item.user}} </span>
                            </div>
                            
                        </div>
                       
                    </b-list-group-item>
                   
                </b-list-group>
            </b-card>
-->


// WEBPACK FOOTER //
// src/components/Cards.vue